import * as actions from '../../redux/actions';

import React, { Component } from 'react';

import CommonService from '../../../../services/commonService';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

export const AboutUsIconSection = props => {
	const operator = CommonService.getLocal('op');

	const renderIconsAndText = (item, key, length) => {
		return (
			<div
				className={
					key + 1 != length && (key + 1) % 3 != 0
						? 'single-item-container '
						: 'single-item-container'
				}
				style={{ width: length <= 3 ? `${100 / length}%` : '33%' }}
			>
				<div className="single-item">
					<div>
						<img src={item.icon} alt="icon" className="about-icon" />
					</div>
					<div className="details">
						<div className="font12 title">{item.caption}</div>
						<div className="font9 desc">{item.desc}</div>
					</div>
				</div>

				{/* { <div className="borderRight-about-icons"></div> : ' '} */}
			</div>
		);
	};

	return (
		<div id={props.id} className="themes-about-us-icon-section new-container ">
			<div className="about-us-icons-main-container">
				<div>
					{props.smallHeading && (
						<div
							className="outlined-title"
							style={{
								color:
									operator && operator.color_codes && operator.color_codes.secondary_color
										? operator.color_codes.secondary_color
										: null,
							}}
						>
							{/* <div className="title-side-line"></div> */}
							<div className="font20 less-bold-text mb5">{props.smallHeading}</div>
						</div>
					)}
				</div>
				<div className="icons-container">
					{props.iconsAndTexts.map((item, key) => {
						return renderIconsAndText(item, key, props.iconsAndTexts.length);
					})}
				</div>
			</div>

			{props.aboutText && (
				<div
					className="about-text"
					style={{
						background:
							operator && operator.color_codes && operator.color_codes.tertiary_color
								? operator.color_codes.tertiary_color
								: '',
						color:
							operator && operator.color_codes && operator.color_codes.secondary_color
								? operator.color_codes.secondary_color
								: null,
					}}
				>
					<GetText name={operator.operator_name} />
				</div>
			)}
		</div>
	);
};

const GetText = ({ name }) => {
	if (name === 'kennybus') {
		return (
			<div>
				<strong>Kenny Bus</strong> es una empresa de transporte y viajes fundada en el año 1969.
				<strong> Completamente dedicados a ofrecer un servicio de calidad y primera clase, </strong>
				contamos con una flota variada de autobuses para que nuestros clientes puedan elegir y tener
				un viaje cómodo en todo momento.
				<br />
				<br />
				Nuestro personal está profesionalmente capacitado para dar un buen servicio, con el que
				deseamos ganar la verdadera confianza y los corazones de nuestros clientes.
			</div>
		);
	} else if (name === 'viatur') {
		return (
			<div>
				<strong>Vía Tur Ltda.</strong> es una empresa de buses interurbanos que nació el 27 de
				septiembre de 1979 y fue creada por don Gastón Zegard Thomas. Vía Tur nació para dar
				continuidad a la empresa Vía Sur Ltda., creada en el año 1947, siendo el dueño su padre, don
				Akli Zegard Farat.
				<br />
				En el año 1960, don Gastón Zegard Thomas ingresa como socio a Vía Sur Ltda. , empresa que
				por esos años fue una de las grandes de Sudamérica en el transporte de pasajeros.
				<br />
				<br />
				<strong> Vía Tur Ltda., </strong>
				actualmente presta servicios de transporte interurbanos desde Santiago hacia Temuco,
				Valdivia, Osorno, Puerto Montt y viceversa, con asientos tanto semi cama como cama.
			</div>
		);
	}
	else if (name === 'lineaazul') {
		return (
			<div>
				Los inicios de la empresa se remontan al  servicio de recorrido San Carlos-Concepción. En cinco años Línea Azul logró posicionarse dentro de las empresas líderes en el transporte de pasajeros a nivel país.
				<br />
				Con más de sesenta años de experiencia en el transporte de pasajeros y la vocación de seguir innovando, Buses Línea Azul se ha posicionado como una de las empresas líderes en el rubro a nivel país. Una característica llamativa de la empresa es que cada uno de sus buses tiene una pintura distinta, siendo algunos unas verdaderas obras de arte.
				<br />

				Gracias al reforzamiento de la marca y la asertividad de sus continuadores, la empresa ha posicionado a Buses Línea Azul como la alternativa local más reconocida en el traslado de pasajeros.<br />
				Actualmente la empresa realiza sus recorridos en la ruta Chillán – Concepción, ampliando prontamente sus rutas a otras ciudades


			</div>
		);
	}
	return <div />;
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		themes: state.themes,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(AboutUsIconSection);



// WEBPACK FOOTER //
// ./src/features/themes/common/about-us/AboutUsIconSection3.js